import home from "./pages/home";
import notFound from "./pages/not_found";
import client from "./pages/client";
import corporations from "./pages/corporations";
import clients from "./pages/clients";
import moUploadDocuments from "./pages/mo_upload_documents";
import subscriptionInformation from "./pages/subscription_information";
import subscriptionSummary from "./pages/subscription_summary";
import subscriptions from "./pages/subscriptions";
import products from "./pages/products";
import product from "./pages/product";
import documentTemplateSubscription from "./pages/document_template_subscription";
import consortium from "./pages/consortium";
import investorInvitations from "./pages/investor_invitations";
import account from "./pages/account";
import login from "./pages/login";
import moSubscriptions from "./pages/mo_subscriptions";
import moManualSubscription from "./pages/mo_manual_subscription";
import moSubscriptionSummary from "./pages/mo_subscription_summary";
import partners from "./pages/partners";
import createPartner from "./pages/create_partner";

export default {
	home: home,
	not_found: notFound,
	client: client,
	corporations: corporations,
	clients: clients,
	mo_upload_documents: moUploadDocuments,
	subscription_information: subscriptionInformation,
	subscription_summary: subscriptionSummary,
	subscriptions: subscriptions,
	products: products,
	product: product,
	document_template_subscription: documentTemplateSubscription,
	consortium: consortium,
	investor_invitations: investorInvitations,
	account: account,
	login: login,
	mo_subscriptions: moSubscriptions,
	mo_manual_subscription: moManualSubscription,
	mo_subscription_summary: moSubscriptionSummary,
	partners: partners,
	create_partner: createPartner,
};
